import {memo, PropTypes, shapeComponent, ShapeComponent, StyleSheet, View} from "shared/base"
import React, {useContext, useMemo} from "react"
import {ChalkyLayoutInputContainerContext} from "components/chalky-layout/input-container"
import CountriesSelect from "./countries-select"
import {digg} from "diggerize"
import InputContainer from "./input-container"
import InputField from "./input-field"

const styles = StyleSheet.create({
  phoneNumberCountryContainer: {marginRight: 10},
  phoneNumberInputFieldContainer: {flex: 1}
})

/**
 * @typedef {object} ComponentsUtilsPhoneNumberInnerProps
 * @property {number} containerWidth
 * @property {unknown} country
 * @property {object} countrySelectProps
 * @property {object} dataSet
 * @property {string} number
 * @property {unknown} onChangeCountry
 * @property {unknown} onChangeNumber
 */

/**
 * @typedef {object} ComponentsUtilsPhoneNumberInnerState
 * @property {unknown} phoneNumber
 * @property {unknown} width
 */

/**
 * @extends {ShapeComponent<ComponentsUtilsPhoneNumberInnerProps, ComponentsUtilsPhoneNumberInnerState>}
 */
class ComponentsUtilsPhoneNumberInner extends ShapeComponent {
  /** @type {ComponentsUtilsPhoneNumberInnerState} */
  state = {
    phoneNumber: null,
    width: null
  }

  static defaultProps = {
    containerWidth: null,
    country: null
  }

  static propTypes = {
    containerWidth: PropTypes.number,
    country: PropTypes.object.isRequired,
    countrySelectProps: PropTypes.object,
    dataSet: PropTypes.object,
    number: PropTypes.string
  }

  setup() {
    const {country} = this.p


    this.countryValue = useMemo(() => {
      if (country) {
        return [digg(country, "code")]
      }
    }, [country?.code])
  }

  countrySelectProps() {
    const {onChange, ...restProps} = this.props.countrySelectProps || {}

    return restProps
  }

  inputProps() {
    const {country, countrySelectProps, number, onChangeCountry, onChangeNumber, ...restProps} = this.props

    return restProps
  }

  render() {
    const chalkyLayoutInputContainerContext = useContext(ChalkyLayoutInputContainerContext)
    const inputFieldProps = {}

    if (chalkyLayoutInputContainerContext != "withinChalkyLayoutInputContainer") {
      inputFieldProps.icon = "phone"
    }

    if (this.p.number != null) {
      inputFieldProps.value = this.p.number
    }

    return (
      <View onLayout={this.tt.onContainerLayout} style={this.containerLayoutStyle ||= {flexDirection: "row", alignItems: "center"}}>
        <View
          dataSet={this.phoneNumberCountryContainerDataSet ||= {class: "phone-number-country-container"}}
          style={styles.phoneNumberCountryContainer}
        >
          <ChalkyLayoutInputContainerContext.Provider value={null}>
            <CountriesSelect
              id="phone_country_select"
              onChange={this.tt.onCountryChanged}
              optionsWidth={this.p.containerWidth || this.s.width}
              values={this.tt.countryValue}
              woofInputStyling
              {...this.countrySelectProps()}
            />
          </ChalkyLayoutInputContainerContext.Provider>
        </View>
        <View
          dataSet={this.phoneNumberInputFieldContainerDataSet ||= {class: "phone-number-input-field-container"}}
          style={styles.phoneNumberInputFieldContainer}
        >
          <InputField
            dataSet={this.inputFieldDataSet ||= {class: "phone-input-field"}}
            onChangeText={this.p.onChangeNumber}
            {...inputFieldProps}
            {...this.inputProps()}
          />
        </View>
      </View>
    )
  }

  onCountryChanged = (option) => {
    if (this.props.countrySelectProps?.onChange) {
      this.props.countrySelectProps.onChange(option)
    }

    this.p.onChangeCountry(option)
  }

  onContainerLayout = (e) => this.setState({width: digg(e, "nativeEvent", "layout", "width")})
}

const ComponentsUtilsPhoneNumber = memo(shapeComponent(ComponentsUtilsPhoneNumberInner))

/**
 * @typedef {object} ComponentsUtilsPhoneNumberWithInputContainerInnerProps
 * @property {unknown} dataSet
 */

/**
 * @typedef {object} ComponentsUtilsPhoneNumberWithInputContainerInnerState
 * @property {unknown} width
 */

/**
 * @extends {ShapeComponent<ComponentsUtilsPhoneNumberWithInputContainerInnerProps, ComponentsUtilsPhoneNumberWithInputContainerInnerState>}
 */
class ComponentsUtilsPhoneNumberWithInputContainerInner extends ShapeComponent {
  /** @type {ComponentsUtilsPhoneNumberWithInputContainerInnerState} */
  state = {
    width: null
  }


  render() {
    const {dataSet, ...restProps} = this.props

    return (
      <InputContainer
        dataSet={this.inputContainerDataSet ||= {component: "utils/phone-number"}}
        onLayout={this.tt.onInputContainerLayout}
        {...restProps}
      >
        <ComponentsUtilsPhoneNumber containerWidth={this.s.width} {...this.props} />
      </InputContainer>
    )
  }

  onInputContainerLayout = (e) => this.setState({width: digg(e, "nativeEvent", "layout", "width")})
}

const ComponentsUtilsPhoneNumberWithInputContainer = memo(shapeComponent(ComponentsUtilsPhoneNumberWithInputContainerInner))

export {ComponentsUtilsPhoneNumber}
export default ComponentsUtilsPhoneNumberWithInputContainer
